import React from 'react';
import {
  Grid, IconButton, TextField, Box, Stack,
} from '@mui/material';
import Typography500 from 'views/common/components/UI/Typography500';
import { RadioGroupFilterV2 } from 'views/rebranded-module/common/components';
import StyleBox from 'views/rebranded-module/location-module/LocationsViewV2/components/LocationsFilter/LocationsFilter.styles';
import { RiSearchLine, RiEqualizerLine } from 'react-icons/ri';

const LocationsFilter = (props) => {
  const {
    handlesearch,
    handleChange,
    searchPlacholder,
    className,
    filter,
    handleClick,
    handleFiltersOverlayOpen,
    content,
  } = props;

  return (
    <StyleBox>
      <Box className="showMOBILE">
        <Stack direction="row" spacing={1.25}>
          <Box className="LFSearchInputContainer" flex={1}>
            <TextField
              className="LFInput"
              id="search"
              value={null}
              onChange={handleChange}
              placeholder={
                searchPlacholder
                || content.RadioFilterComponent.searchLocationName
              }
              fullWidth
            />
            <IconButton
              onClick={handlesearch}
              className="LFSearchBtn"
              size="large">
              <RiSearchLine />
            </IconButton>
          </Box>
          <IconButton
            className="LFFilterButton"
            color="secondary"
            onClick={handleFiltersOverlayOpen}>
            <RiEqualizerLine />
          </IconButton>
        </Stack>
      </Box>
      <Box className="showTabletAndDesktop">
        <Grid
          container
          spacing={3}
          pb={1.15}
          className={`${className} RadioFilter`}>
          <Grid item display="flex" alignItems="center">
            <Typography500 variant="h6" component="p">
              {content.LocationsPage.filterBy}
            </Typography500>
          </Grid>
          <Grid item>
            <RadioGroupFilterV2
              filter={filter}
              handleClick={handleClick}
              cmsContent={content.RadioFilterComponent}
            />
          </Grid>
        </Grid>
      </Box>
    </StyleBox>
  );
};

export { LocationsFilter };
